import type { AnimalCreateInput } from '@gql/graphql';
import { AnimalTypeEnum } from '@gql/graphql';
import type { BuyerAnimalFormValues } from '@presentation/components';
import { useCallback } from 'react';

export const useAnimalCreateBuilder = () => {
  const animalCreateBuilder = useCallback((values: Partial<BuyerAnimalFormValues>) => {
    const data: AnimalCreateInput = {
      type: values.type ?? AnimalTypeEnum.OTHER,
      name: values.name,
      birthday: values.birthday?.toISOString(),
      birthdayType: values.birthdayType,
      gender: values.gender,
      sterilized: values.sterilized,
      calved: values.calved,
      size: values.size,
      sensitivities: values.sensitivities,
    };

    if (values.type === AnimalTypeEnum.DOG && values.dogInfo) {
      data.dogInfos = {
        create: {
          physicalCondition: values.dogInfo.physicalCondition,
          medicalAffections: {
            create: (values.dogInfo.medicalAffections ?? []).map((medicalAffection) => ({
              affectionType: medicalAffection,
            })),
          },
          pedigree: values.dogInfo.pedigree,
          dogBreed: { connect: { id: values.dogInfo.breedId } },
        },
      };
    }

    return { data };
  }, []);

  return { animalCreateBuilder };
};
